
import React,{ useState } from 'react'
import { AiOutlineSearch } from "react-icons/ai";
import { DilContext, useContext } from '../ContextDil';
import {
   
    HeaderContainer,
    HeaderWrapper,
  Hdr,
   Search,
   SelLang
   
  } from "./style";


const Header = ({ handleSearch,baslik}) => {
  const [language, setLanguage] = useState("tr");
  const {setLang} = useContext(DilContext);

  const langChange = e => {
    
     
     // lang = localStorage.getItem("lang");
      setLang(e.target.value)
      setLanguage(e.target.value);
    // console.log(language);
    //  localStorage.setItem("lang",  e.target.value);
   
  };

  return (
    <HeaderWrapper>
    <HeaderContainer>
    <Hdr>{baslik}</Hdr>
    <Search>
       
       <input className='searchInput' type="text" name="search" placeholder="Search"
        onChange={handleSearch}
       />
        <button className='searchButton'>
          <AiOutlineSearch fontSize="1rem" />
         </button>      
        
       </Search>
     <SelLang
    
          onChange={e => langChange(e)}
          name="lang"
          value={language} >

          <option  value="en">
            English
          </option>
          <option  value="tr">
            Türkçe
          </option>
         
       
     </SelLang>
    </HeaderContainer>
    </HeaderWrapper>
  )
}

export default Header;
